import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageI } from 'src/app/auth/modelos/tokenstorage.inteface';
import { TokenStorageService } from 'src/app/services/api/TokenStorageService';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {
  

  constructor(
   
    private tokenStorage: TokenStorageService,
    private router:Router
    
  ){}


  ngOnInit(): void {
    
    if (this.tokenStorage.getToken()==null) {
    
     // this.roles = this.tokenStorage.getUser();
      this.router.navigateByUrl('#/login');
    }

  
  }


}
